import { Lock } from 'lucide-react';
import { useContext } from 'react';

import { LockedHintContext, VIEW_ONLY_HINT } from './locked-hint';

export const READ_ONLY_HINT = VIEW_ONLY_HINT;

/** Marks a section the viewer can read but not change; the page's reason is its tooltip. */
export function LockedPill() {
  const hint = useContext(LockedHintContext) ?? READ_ONLY_HINT;
  return (
    <span
      className="nb-pill"
      title={hint}
      style={{
        height: 22,
        fontSize: 10,
        padding: '0 8px',
        gap: 5,
        fontWeight: 700,
        letterSpacing: '.03em',
        background: 'var(--nb-surface-2)',
        color: 'var(--nb-muted)',
        borderColor: 'transparent',
      }}
    >
      <Lock size={11} aria-hidden="true" />
      Locked
    </span>
  );
}
